import { render, staticRenderFns } from "./circles.vue?vue&type=template&id=b64924b6&scoped=true&"
import script from "./circles.vue?vue&type=script&lang=js&"
export * from "./circles.vue?vue&type=script&lang=js&"
import style0 from "./circles.vue?vue&type=style&index=0&id=b64924b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64924b6",
  null
  
)

export default component.exports